module.exports = __webpack_public_path__ + "static/media/IIC2.27c69c8f.jpg";